// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"84e4bce6","546":"5a24e1f0"}[chunkId] + ".chunk.css";
};